// src/vimSdkClient.ts
import {
  string as stringType,
  literal,
  type,
  union,
  partial,
  array,
  intersection
} from "io-ts";
import loadDynamicScript from "@getvim/utils-load-dynamic-script";
var SdkConfigValidator = type({
  sdkKey: stringType,
  options: intersection([
    type({
      env: union([
        literal("local"),
        literal("dev"),
        literal("staging"),
        literal("sandbox"),
        literal("prod"),
        literal("localui")
      ])
    }),
    partial({
      supportedWidgets: array(union([literal("SCHEDULING"), literal("SEARCH_AND_ACTION"), literal("RESCHEDULE")]))
    })
  ])
});
var VimSdkClient = class {
  async init(...args) {
    if (!(window == null ? void 0 : window.Vim) || !this.client) {
      try {
        if (!(window == null ? void 0 : window.Vim)) {
          await loadDynamicScript("vimSdk", "https://js.getvim.com/web/v1.6/sdk.js");
          const { Vim } = window;
          if (typeof Vim === "undefined") {
            throw new Error("Could not initialize VIM SDK");
          }
        }
        if (!this.client) {
          this.client = await window.Vim(...args);
        }
      } catch (error) {
        if (error) {
          throw error;
        }
        throw new Error("Could not initialize VIM SDK");
      }
    }
    return true;
  }
  showBookingDialog(...args) {
    return Promise.resolve().then(() => {
      if (!this.client) {
        throw new Error("SDK is not initialized");
      }
      return this.client.showBookingDialog(...args);
    }).catch((error) => {
      if (error) {
        throw error;
      }
      throw new Error("Error occurred while booking");
    });
  }
  closeBookingDialog() {
    return Promise.resolve().then(() => {
      if (!this.client) {
        throw new Error("SDK is not initialized");
      }
      return this.client.closeDialog();
    });
  }
  getProviderAvailability(...args) {
    return Promise.resolve().then(() => {
      if (!this.client) {
        throw new Error("SDK is not initialized");
      }
      return this.client.getProviderAvailability(...args);
    }).catch((error) => {
      if (error) {
        throw error;
      }
      throw new Error("Could not get provider availability");
    });
  }
  selectProvider(...args) {
    return Promise.resolve().then(() => {
      if (!this.client) {
        throw new Error("SDK is not initialized");
      }
      return this.client.selectProvider(...args);
    }).catch((error) => {
      if (error) {
        throw error;
      }
      throw new Error("Could not get select provider");
    });
  }
  showRescheduleDialog(...args) {
    return Promise.resolve().then(() => {
      if (!this.client) {
        throw new Error("SDK is not initialized");
      }
      return this.client.showRescheduleDialog(...args);
    }).catch((error) => {
      if (error) {
        throw error;
      }
      throw new Error("Error occurred while rescheduling");
    });
  }
};
var vimSdkClient_default = new VimSdkClient();
export {
  SdkConfigValidator,
  vimSdkClient_default as default
};
//# sourceMappingURL=index.js.map
